/* src/services/SkillsService.js */
import apiClient from './api'

export const SkillsService = {

  mapFromApi(data) {
    return {
      id: data.id,
      name: data.name || '',
      description: data.description || ''
    }
  },

  mapToApi(skill) {
    return {
      name: skill.name,
      description: skill.description
    }
  },

  async getAll() {

    try {

      const response = await apiClient.get('operators/skills/')

      if (!Array.isArray(response.data)) {

        console.error("Il server non ha restituito un array:", response.data)

        return []
      }

      return response.data.map(item => this.mapFromApi(item))
    } 
    catch (error) {

      console.error("Errore nel recupero skills:", error)
      throw error
    }
  },

  async create(skill) {

    const payload = this.mapToApi(skill)
    const response = await apiClient.post('booking/skills/', payload)
    return this.mapFromApi(response.data)
  },

  async update(id, skill) {

    const payload = this.mapToApi(skill)
    const response = await apiClient.put(`booking/skills/${id}/`, payload)
    return this.mapFromApi(response.data)
  },

  async delete(id) {

    return await apiClient.delete(`booking/skills/${id}/`)
  }
}
